import { render, staticRenderFns } from "./Plans.vue?vue&type=template&id=2246a7ac&"
import script from "./Plans.vue?vue&type=script&lang=js&"
export * from "./Plans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports